import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Book, MessageSquare, Rss, HelpCircle, User, BarChart, Settings, Mail } from 'lucide-react';
import AdminLayout from '../../components/admin/AdminLayout';

const AdminDashboard = () => {
  const sections = [
    {
      title: 'Events Management',
      description: 'Create, edit, and manage upcoming events',
      icon: Calendar,
      path: '/admin/events',
      color: '#00FFD1'
    },
    {
      title: 'Journey Stories',
      description: 'Update past event highlights and stories',
      icon: Book,
      path: '/admin/journey',
      color: '#64C8FF'
    },
    {
      title: 'Testimonials',
      description: 'Manage community testimonials and reviews',
      icon: MessageSquare,
      path: '/admin/testimonials',
      color: '#00FFD1'
    },
    {
      title: 'Nerd Feed',
      description: 'Curate learning content for the community',
      icon: Rss,
      path: '/admin/deft-feed',
      color: '#64C8FF'
    },
    {
      title: 'FAQs',
      description: 'Update frequently asked questions',
      icon: HelpCircle,
      path: '/admin/faqs',
      color: '#00FFD1'
    },
    {
      title: 'Founder & Team',
      description: 'Edit founder profile and information',
      icon: User,
      path: '/admin/founder',
      color: '#64C8FF'
    },
    {
      title: 'Contact Info',
      description: 'Manage email, social links & registration URL',
      icon: Mail,
      path: '/admin/contact',
      color: '#00FFD1'
    },
    {
      title: 'Metrics',
      description: 'Update site metrics and statistics',
      icon: BarChart,
      path: '/admin/metrics',
      color: '#64C8FF'
    },
    {
      title: 'Account Settings',
      description: 'Change password and manage settings',
      icon: Settings,
      path: '/admin/settings',
      color: '#00FFD1'
    }
  ];

  return (
    <AdminLayout>
      <div className="space-y-8">
        <div>
          <h1 className="display-large text-white mb-2">Admin Dashboard</h1>
          <p className="body-large text-white/85">Manage your Deft Experiences website content</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <Link
                key={section.path}
                to={section.path}
                className="group bg-white/5 border border-white/25 rounded-xl p-6 hover:bg-white/10 transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-white/10 rounded-lg group-hover:bg-white/15 transition-colors">
                    <IconComponent size={24} style={{ color: section.color }} />
                  </div>
                  <div className="flex-1">
                    <h3 className="heading-3 text-white mb-2 group-hover:text-[#00FFD1] transition-colors">
                      {section.title}
                    </h3>
                    <p className="body-small text-white/85">{section.description}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="bg-[#00FFD1]/10 border border-[#00FFD1]/30 p-6 rounded-lg">
          <h3 className="heading-3 text-[#00FFD1] mb-2">Quick Tips</h3>
          <ul className="body-small text-white/85 space-y-2">
            <li>• Click any section above to manage that content</li>
            <li>• Changes are saved immediately to the database</li>
            <li>• All updates will reflect on the live website instantly</li>
            <li>• Use high-quality images (recommended 1920x1080 or higher)</li>
            <li>• Keep text concise and professional for best user experience</li>
            <li>• Change your default password in Account Settings</li>
          </ul>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
